import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renameContainer from '../../../actions/renameContainer';
import RenameContainerButton from './RenameContainerButton';
import { create } from '../../../helpers/validationFunctionFactory';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { estimates, containers } = estimateBuilder.entities;
  const { selectedEstimate } = estimateBuilder.uiState;

  const containersInContext = estimates.byId[selectedEstimate].containers;

  const nameList = containersInContext
    .filter(givenId => givenId !== ownProps.containerId)
    .map(givenId => containers.byId[givenId].name);

  const validateFunction = create(nameList, 100, 'Room name');

  return {
    validate: validateFunction,
    defaultName: containers.byId[ownProps.containerId].name,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ renameContainer }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RenameContainerButton);
